import React, {
  Dispatch,
  PropsWithChildren,
  useCallback,
  useState,
} from 'react'
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { PasswordPinToggle } from 'components/PasswordPinToggle'

import { MerchantIdentificationTypes } from 'types/merchant'
import { useCanUI } from 'hooks/useCanUI'

import { isWFClient } from 'setups/controller'
import { projectClient } from 'constants/project'

interface PropsTypes {
  identification: MerchantIdentificationTypes
  selectedMerchantIdentificationSet: Dispatch<MerchantIdentificationTypes>
  isMerchantIdentificationEditSet: Dispatch<boolean>
}

const IdentificationItem = ({
  identification,
  selectedMerchantIdentificationSet,
  isMerchantIdentificationEditSet,
}: PropsWithChildren<PropsTypes>): React.ReactElement => {
  const { isMerchantIdentificationUpdateStatus } = useCanUI()

  return (
    <>
      <tr className="py-2 text-black bg-white border-b-2 cursor-pointer hover:bg-gray-600">
        <td className="py-2 pl-6 overflow-hidden overflow-ellipsis whitespace-nowrap">
          <span className="tracking-wider">{identification.ident}</span>
        </td>
        <td className="py-2 pl-6 overflow-hidden overflow-ellipsis whitespace-nowrap">
          <span className="tracking-wider">{identification.identTypeName}</span>
        </td>
        {isWFClient(projectClient) && (
          <td className="py-2 pl-6 overflow-hidden overflow-ellipsis whitespace-nowrap">
            <PasswordPinToggle passwordpin={identification.password} />
          </td>
        )}
        <td className="py-2 pl-6 overflow-hidden overflow-ellipsis whitespace-nowrap">
          <span className="tracking-wider">{identification.statusName}</span>
        </td>
        <td className="py-2 pl-6 text-right">
          {isMerchantIdentificationUpdateStatus && (
            <button
              type="button"
              className="relative px-1 ml-1 text-center transition duration-150 border border-gray-500 rounded-sm focus:outline-none focus:shadow-outline group hover:border-primary"
              data-tip="Change Status"
              onClick={() => {
                selectedMerchantIdentificationSet(identification)
                isMerchantIdentificationEditSet(true)
              }}
            >
              <Icon
                data-tip="Edit"
                icon={faPencilAlt}
                className="text-gray-500 group-hover:text-primary"
              />
            </button>
          )}
        </td>
      </tr>
    </>
  )
}

export default IdentificationItem
